import { Button } from "@mui/material";
import React from "react";

export default () => {
  return (
    <section className="w-full flex flex-cols md:flex-row mt-5 md:mt-20 items-center justify-between">
      <div className="flex flex-col">
        <div className="abc-regular text-2xl md:text-4xl font-bold  text-black md:w-96">
          <h1>Free, Best Biodata Maker for marriage.</h1>
        </div>
        <p className="abc-regular text-gray-800 text-md font-bold md:text-xl md:w-35rem mt-5">
          Craft your standout marriage biodata effortlessly! User-friendly,
          elegant formats for a lasting impression. Simplify your journey with
          just a few clicks!
        </p>
        <div className="mt-6 ">
          <Button
            onClick={() => {
              document
                .getElementById("create-biodata")
                .scrollIntoView({ behavior: "smooth" });
            }}
            className="mt-10"
            variant="contained"
            color="secondary"
          >
            <p className="abc-bold text-white">Create My Biodata</p>
          </Button>
        </div>
      </div>
      <div
        className="flex-row hover:scale-110 hidden md:flex"
        style={{ transition: "transform .5s" }}
      >
        <img
          className="-mr-10"
          style={{ transform: "rotate(-10deg)" }}
          src={"https://d16akdef0hveqs.cloudfront.net/bgs/b6.png"}
          width={298} height={421}
        />
        <img src={"https://d16akdef0hveqs.cloudfront.net/bgs/b3.png"} className="z-10 -mt-10" loading="lazy" width={298} height={421} />
        <img
          className="-ml-10"
          src={"https://d16akdef0hveqs.cloudfront.net/bgs/b1.png"}
          width={298} height={421}
          style={{ transform: "rotate(10deg)" }}
        />
      </div>
    </section>
  );
};
